import {useSelector} from 'react-redux'
import {
  getOfferAccessFlowSettings,
  getOfferHasGhaOrGvrPreferredRate,
  getShowTotalPrices,
  getShowTotalPriceToggle
} from 'modules/sapiSearch/selectors'
import {SearchOffer} from 'modules/sapiSearch/slice'

export const useShowTotalPriceGhaOrGvrPreferredRate = (
  offer: SearchOffer,
  hotelId: string
) => {
  const showTotalPrices = useSelector(getShowTotalPrices)
  const showTotalPriceToggle = useSelector(getShowTotalPriceToggle)

  const {isSpecial} = useSelector(state =>
    getOfferAccessFlowSettings(state, hotelId, offer?.id)
  )

  const offerHasGhaOrGvrPreferredRate = useSelector(state =>
    getOfferHasGhaOrGvrPreferredRate(state, offer)
  )

  return (
    isSpecial &&
    offerHasGhaOrGvrPreferredRate &&
    !showTotalPrices &&
    showTotalPriceToggle
  )
}
